<template>
  <div class="attr">
    <CommonAttr />
    <el-form>
      <el-form-item label="背景颜色">
        <el-color-picker v-model="curComponent.style.background" show-alpha />
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import ace from 'ace-builds'
import 'ace-builds/src-min-noconflict/theme-chrome'
import 'ace-builds/src-min-noconflict/mode-json5'
import CommonAttr from '../common/CommonAttr.vue'

export default {
  components: { CommonAttr },
  data() {
    return {
      dialogVisible: false,
      charts: [
        {
          title: 'bar',
          name: '柱状图'
        },
        {
          title: 'scatter',
          name: '散点图'
        },
        {
          title: 'line',
          name: '折线图'
        }
      ]
    }
  },
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    },
    option() {
      return this.$store.state.compose.curComponent.propValue.option
    }
  },
  methods: {
    openStaticWinbox() {
      this.dialogVisible = !this.dialogVisible
      this.$nextTick(() => {
        ace.config.set('basePath', 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.14/')
        this.editor = ace.edit(this.$refs.ace, {
          maxLines: 28,
          minLines: 28,
          fontSize: 14,
          theme: 'ace/theme/chrome',
          mode: 'ace/mode/json5',
          tabSize: 4,
          readOnly: false,
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true
        })
        // 初始化图表数据在editor中
        const data = JSON.stringify(this.curComponent.propValue.option.series.data)
        const xAxis = JSON.stringify(this.curComponent.propValue.option.xAxis.data)
        this.editor.setValue(data + '\n' + xAxis)
      })
    },

    // 寻找数组[]
    findstring(str, ch1, ch2) {
      return str.substr(str.indexOf(ch1), str.indexOf(ch2) + 1)
    },

    // 更新数据editor中的数据修改
    updatedata() {
      const str = this.editor.getValue()
      const Arrdata = this.findstring(str, '[', ']')
      const ArrXAxis = this.findstring(str.substr(str.indexOf(']') + 1), '[', ']')
      this.curComponent.propValue.option.series.data = JSON.parse(Arrdata)
      this.curComponent.propValue.option.xAxis.data = JSON.parse(ArrXAxis)
      this.$message.success('更新成功')
      this.dialogVisible = !this.dialogVisible
    },

    // 更换表格类型
    selectchart(chart) {
      this.curComponent.propValue.option.series.type = chart
    }
  }
}
</script>

<style>
.ace {
    margin: 5px;
    margin-top: -20px;
    height: 600px;
    width: 1100px;
}

.attr {
    margin: 13px;
}
</style>
